import type { FC } from 'react';
import { useState } from 'react';
import { Button, Alert, Spinner } from '../../lib';
import { HiInformationCircle } from 'react-icons/hi';
import apiServices from '../../services/apiServices';
import adminServices from '../../services/adminServices';

const inputClass = "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500";

const CompetitionReportPage: FC = () => {
  const svc = new apiServices();
  const isAdmin = svc.isloggedin() && svc.hasHole("Admin");

  const [start, setStart] = useState<string>("");
  const [end, setEnd] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  if (!isAdmin) {
    return (
      <Alert color="failure" icon={HiInformationCircle}>
        <span>This report is only available to administrators.</span>
      </Alert>
    );
  }

  const rangeInvalid = !!start && !!end && start > end;

  const download = () => {
    setErrorMessage("");
    setLoading(true);
    new adminServices().downloadCompetitionReport(start, end)
      .catch((e: any) => setErrorMessage(e?.message || "Download failed"))
      .finally(() => setLoading(false));
  };

  return (
    <div className="max-w-xl">
      <h1 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Competition Report</h1>
      <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
        Downloads a spreadsheet (CSV) of subsidy requests with project, contractor, general contractor and competition details.
        Leave a date blank to not limit that end of the range. Dates filter on the bid date.
      </p>

      {errorMessage && <Alert color="failure" icon={HiInformationCircle} className="mb-4">
        <span>{errorMessage}</span>
      </Alert>}

      <div className="grid gap-6 mb-6 md:grid-cols-2">
        <div>
          <label htmlFor="reportStart" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Bid Date From</label>
          <input id="reportStart" type="date" value={start} onChange={e => setStart(e.target.value)} className={inputClass} />
        </div>
        <div>
          <label htmlFor="reportEnd" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Bid Date To</label>
          <input id="reportEnd" type="date" value={end} onChange={e => setEnd(e.target.value)} className={inputClass} />
        </div>
      </div>

      {rangeInvalid && <p className="mb-4 text-sm text-red-600">"From" date must be on or before "To" date.</p>}

      <div className="flex items-center gap-4">
        <Button onClick={download} disabled={loading || rangeInvalid}>Download CSV</Button>
        {loading && <Spinner />}
      </div>
    </div>
  );
};

export default CompetitionReportPage;
